<template>
  <section>
    <b-row>
    <b-col cols="12">
      <b-form-group label="For:" description="From Date must be before To Date">
        <b-form-select :disabled="viewOnly" v-model="reportFilters.dateFilter" :options="projectDateOpts" required />
      </b-form-group>
    </b-col>
    <template v-if="reportFilters.dateFilter == 'custom'">
      <div class="col-6">
        <b-form-group label="From Shipped Date:" description="From Date must be before To Date">
          <Flatpickr :disabled="viewOnly" v-model="reportFilters.startDate" :config="flatpickrConfig" class="form-control flatpickr-input"
            placeholder="Select date" required />
        </b-form-group>
      </div>
      <div class="col-6">
        <b-form-group label="To Date:">
          <Flatpickr :disabled="viewOnly" v-model="reportFilters.endDate" :config="flatpickrConfig" class="form-control flatpickr-input"
            placeholder="Select date" required />
        </b-form-group>
      </div>
    </template>
  </b-row>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import { myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
export default {
  mixins: [myCommonDataMixin],
  name: 'OrderedStorefrontItemsReport-form',
  props: {
    reportFilters: {
      type: Object,
      required: true
    },
    viewOnly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      projectsList: 'getProjectsList',
      myProjs: 'getMyProjects',
      countryCodeList: 'getCountryCodeList',
      USAStateCodeList: 'getUSAStateCodeList'
    })
  },
  data() {
    return {
      projectDateOpts: [
        // { value: '', text: "All" },
        { value: 'this-week', text: 'This Week' },
        { value: 'last-week', text: 'Last Week' },
        { value: 'this-month', text: 'This Month' },
        { value: 'last-month', text: 'Last Month' },
        { value: 'custom', text: 'Custom Date Range' }
      ],
      flatpickrConfig: {
        altFormat: 'j F Y',
        altInput: true,
        dateFormat: 'Y-m-d'
      }
    }
  }
}
</script>

<style>

</style>
